module.exports = __webpack_public_path__ + "icon-spring-framework.ff-QLWXP.svg";